import SEO from "@/components/SEO";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import AppsSection from "@/components/AppsSection";
import WhyPostings from "@/components/WhyPostings";
import About from "@/components/About";
import Team from "@/components/Team";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";

export default function Home() {
  return (
    <>
      <SEO
        title="Postings Inc. | Bookkeeping & Payroll for Canadian Businesses — Newmarket, Ontario"
        description="Professional bookkeeping, payroll and business financial support for Canadian businesses. QuickBooks Online bookkeeping, CRA payroll remittances, T4s & ROEs. Serving Newmarket, York Region and Northumberland."
      />
      <Hero />
      <Marquee />
      <Services />
      <Manifesto />
      <AppsSection />
      <WhyPostings />
      <About />
      <Team />
      <Testimonials />
      <FinalCTA />
    </>
  );
}
